import { ResponseContent } from '../Models/ResponseContent';
import { getApi, patchApi, postApi } from './Api';


export const loginAdmin = async (email:string, password:string) => {
    try{
        return await postApi<ResponseContent>('auth/login', {email, password})
    }
    catch(error){
        throw error;
    }
}

